import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from 'react-i18next';

function SchoolYearSelector({
  activeSchoolYearStartYear,
  options,
  onChange,
}) {
  const { t: tr } = useTranslation();
  return (
    <div className="manage-school-year-selector">
      <span className="manage-school-year-selector-label">{tr("common:schoolYear")}</span>
      <select
        id="activeSchoolYearStartYear"
        name="activeSchoolYearStartYear"
        aria-label={tr("common:schoolYear")}
        className="form-control form-control-sm manage-school-year-selector-input"
        value={activeSchoolYearStartYear}
        onChange={(event) => onChange(Number(event.target.value))}
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.text}
          </option>
        ))}
      </select>
    </div>
  );
}

SchoolYearSelector.propTypes = {
  activeSchoolYearStartYear: PropTypes.number.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.number.isRequired,
    text: PropTypes.string.isRequired,
  })).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default SchoolYearSelector;
